<form [formGroup]="restrictForm">
  <div class="display-flex sdps-p-top_medium sdps-p-left_xx-large sdps-p-bottom_medium">
      <div class="sdps-p-right_xx-large">
          <p-checkbox inputId="restrictBuys" class="emtr-checkbox" binary="true" formControlName="restrictBuys" (ngModelChange)="restrictTypeChanged()"/>
          <label for="restrictBuys" class="sdps-p-left_x-small" [innerHTML]="getConstant.rulesConstant.ruleTypeLabels[rulesCategory]+ ' ' +getConstant.rulesConstant.ruleTypeLabels.buys"></label>
      </div>
      <div class="sdps-p-right_xx-large">
          <p-checkbox inputId="restrictSells" class="emtr-checkbox" binary="true" formControlName="restrictSells" (ngModelChange)="restrictTypeChanged()"/>
          <label for="restrictSells" class="sdps-p-left_x-small" [innerHTML]="getConstant.rulesConstant.ruleTypeLabels[rulesCategory]+ ' ' +getConstant.rulesConstant.ruleTypeLabels.sells"></label>
      </div>
      <div class="sdps-p-right_xx-large" *ngIf="ruleType !== getConstant.rulesConstant.autoComplete.FNDISUTxt">
          <p-checkbox inputId="restrictShortSells" class="emtr-checkbox" binary="true" formControlName="restrictShortSells"
                      [ngClass]="(buttonDisabled ?'on-check':'on-uncheck')" (ngModelChange)="restrictTypeChanged()"/>
                      <label for="restrictShortSells" class="sdps-p-left_x-small" [innerHTML]="getConstant.rulesConstant.ruleTypeLabels[rulesCategory]+ ' ' +getConstant.rulesConstant.ruleTypeLabels.shortSells"></label>

          <sdps-tooltip
                  *ngIf="attributesFormData.ruleType === 'SECTYP' && (restrictForm.get('restrictShortSells').value===true)"
                  class="info-icon-button-border sdps-m-left_x-small" sdps-id="right-tooltip" position="right">
                  <span slot="tooltip-content" [innerHTML]="infoIconMsg"></span>
          </sdps-tooltip>
      </div>
  </div>
</form>

